var startChat = '[data-start-zopim-chat=true]';

function init() {
  $(startChat).on('click', function (e) {
    e.preventDefault();
    $zopim.livechat.window.show();
  });
}

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/start_chat.js